
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/category/[slug]",
      function () {
        return require("private-next-pages/help/category/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/category/[slug]"])
      });
    }
  